<template>
    <v-dialog name="editRow" v-model="level.dialogValues.dialogShow" data-app="true" persistent max-width="900">
      <v-card>

         <CardUpdatableHeader :row="row" :level="level"/>

         <v-card-text>
            <v-container>

               <v-row>
                  <v-col cols="12">
                     <v-text-field v-model="row.sla_name" :disabled="level.dialogValues.form_disabled" outlined required :hint="$t('hints.sla_name')" persistent-hint>
                     </v-text-field>
                  </v-col>
               </v-row>

               <v-row>
                  <v-col cols="12" sm="6">
                     <h4>{{ $t('subtitles.sla_flags') }}</h4>
                     <b-checkbox :disabled="level.dialogValues.form_disabled" v-model="row.sla_active"   @click ="row.sla_active=!row.sla_active">{{ $t('texts.sla_active') }}</b-checkbox>
                     <b-checkbox :disabled="level.dialogValues.form_disabled" v-model="row.sla_positive" @click ="row.sla_positive=!row.sla_positive">{{ $t('texts.sla_positive') }}</b-checkbox>
                     <b-checkbox :disabled="level.dialogValues.form_disabled" v-model="row.sla_computed" @click ="row.sla_computed=!row.sla_computed">{{ $t('texts.sla_computed') }}</b-checkbox>
                  </v-col>
                  <v-col cols="12" sm="6">
                     <h4>{{ $t('subtitles.datetime_interval') }}</h4>
                     <date-picker
                        v-model="datetimes"
                        range
                        :show-second="false"
                        type="datetime"
                        :locale="locale"
                        :lang="lang"
                        @input="pick_dates"
                     >
                     </date-picker>
                     <br/>
                     <b-badge class="m-1" variant="info">{{ $t('texts.sla_duration') }}</b-badge>{{ row.sla_event_duration }}
                  </v-col>
               </v-row>

               <v-row>
                  <h4>{{ $t('subtitles.cus_plf_bindings') }}</h4>
               </v-row>

               <v-row>
                  <v-col cols="12" sm="6">
                     <ddoSelectCustomerReseller :callbacks="CUScallbacks" ref="mySelectCUS" :options="CUSoptions"/>
                  </v-col>

                  <v-col cols="12" sm="6">
                     <ddoSelectPlatform :callbacks="PLFcallbacks" ref="mySelectPLF" :options="PLFoptions"/>
                  </v-col>
               </v-row>

               <v-row>
                  <v-col cols="12">
                     <v-text-field
                        v-model="row.sla_desc"
                        :disabled="level.dialogValues.form_disabled" 
                        :label="$t('texts._desc')"
                        :hint="$t('hints._desc')"
                     ></v-text-field>
                  </v-col>
               </v-row>

               <v-row>
               <v-col v-if="!level.dialogValues.form_create" cols="12">
                  <b-badge class="m-1" variant="info">{{ $t('headers.created_on') }}</b-badge>{{ $api._d(row.sla_create,'long') }}<br/>
                  <b-badge class="m-1" variant="info">{{ $t('headers.updated_on') }}</b-badge>{{ $api._d(row.sla_create,'long') }}
               </v-col>
               </v-row>

            </v-container>
            <small>*{{ $t('texts.requiredfield') }}</small>
         </v-card-text>

         <CardUpdatableFooter :row="row" :level="level"/>

      </v-card>
    </v-dialog>

</template>

<script>
import i18n from '@/plugins/i18n.js';
import ddoAlert from '@/components/ddoAlert.vue';
import CardUpdatable from '@/components/partials/CardUpdatable.vue';
import CardUpdatableHeader from '@/components/partials/CardUpdatableHeader.vue';
import CardUpdatableFooter from '@/components/partials/CardUpdatableFooter.vue';
import ddoSelectPlatform from '@/components/ddoSelectPlatform.vue';
import ddoSelectCustomerReseller from '@/components/ddoSelectCustomerReseller.vue';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/fr';

export default {
    name: 'CardUpdatableSla',
    extends: CardUpdatable,
    components: {
      ddoAlert,
      CardUpdatableHeader,
      CardUpdatableFooter,
      ddoSelectPlatform,
      ddoSelectCustomerReseller,
      DatePicker,
    },

    props: {
    },

    data: function () {
      return {
         show: false,

         dates: new Date().toISOString().substr(0, 19),
         locale: null,
         datetimes: [],
         lang: {
            formatLocale: {
               firstDayOfWeek: 1,
            },
            monthBeforeYear: true,
         },

         PLFcallbacks: {},
         PLFoptions: {
            initial: null,
            required: false,
            disabled: false,
            multiple: false,
            clearable: true,
            item_text: "plf_name",
            item_value: "plf_pk",
            item_disabled: "",
            hide_selected: true,
            label: i18n.t('texts.platform'),
         },

         selectedCUS: {},
         CUScallbacks: {},
         CUSoptions: {
            initial: null,
            selected: null,
            required: false,
            disabled: false,
            multiple: false,
            clearable: true,
            item_text: "cus_name",
            item_value: "cus_pk",
            item_disabled: "",
            hide_selected: true,
            change_on_remove: true,
            label: i18n.t('texts.cer_customer'),
         },
      }
   },

   computed: {
      datesFormatted () {
         if ( Array.isArray(this.dates) ) {
            if ( this.dates.length==2 && this.dates[0]>this.dates[1] ) {
               let tmp = this.dates[0];
               this.dates[0] = this.dates[1];
               this.dates[1] = tmp;
            }
            return this.dates.join(' ~ ')
         } else {
            return this.dates
         }
      },
   },

   created() {
      /*
       * SDO : As today, 2022-06-26, sadly, callbacks do not work. 
       * The standard callbacks are called...
       */
      this.CUScallbacks.refresh_rows = this.build_select_cus;
      this.CUScallbacks.change       = this.change_cus;
      this.PLFcallbacks.refresh_rows = this.build_select_plf;
      this.PLFcallbacks.change       = this.change_plf;
   },

   mounted() {
      this.locale = navigator.language;
   },

   methods: {

      pick_dates(dates) {
         console.log('pick_dates, dates='+JSON.stringify(this.datetimes))
         if ( this.datetimes[0] ) {
            this.level.row.sla_event_start = this.datetimes[0];
         } else {
            this.level.row.sla_event_start = null;
         }
         if ( this.datetimes[1] ) {
            this.level.row.sla_event_stop = this.datetimes[1];
         } else {
            this.level.row.sla_event_stop = null;
         }
         this.level.row.sla_event_duration = this.level.row.sla_event_stop - this.level.row.sla_event_start;
      },

      async refresh_select_plf(key=null) {
         await this.$refs.mySelectPLF.refresh_rows(key);
      },

      async build_select_plf(key=null) {
         //console.log('CardUpdatableSla::build_select_plf, SPECIFIC');
         this.loading = true;
         var { errorinfos, api_response } = await this.$api.getRows(this.$router,'platform');
         this.loading = false;
         return { errorinfos, api_response }
      },

      async change_plf(value,item=null) {
         //console.log('CardUpdatableSla::change_plf, SPECIFIC, value='+value);
         if ( value!=null) {
            this.level.row.plf_pk = value;
         } else {
           this.level.row.plf_pk = null;
         }
      },

      async build_select_cus(key=null) {
         //console.log('CardUpdatableSla::build_select_cus, SPECIFIC');
         this.loading = true;
         var { errorinfos, api_response } = await this.$api.getRows(this.$router,'customerreseller');
         this.loading = false;
         return { errorinfos, api_response }
      },

      /*
       * this dropdown is 'return_object=false'. So, value is an integer, and item is null
       * We have to retrieve item from <select-reference>.items, and store it in this.selectedCUS
       */
      async change_cus(value,item=null) {
         //console.log('CardUpdatableSla::change_cus, SPECIFIC, value='+value);
         this.row.cus_pk = value;
         if ( item!=null ) {
            this.selectedCUS = item;
         } else {
            this.selectedCUS = this.$api._get_by_pk(this.$refs.mySelectCUS.items,value);
         }
      },

   },
}
</script>

<style scoped>
.list-group-item {
  cursor: move;
}
</style>